export const appConfig = {
  hpc: 'http://78.186.223.18:5001/api/v1.1',
  tokenUrl: 'http://78.186.223.18:8762/api',
  ic: 'http://78.186.223.18:6004/api/v1.1',
};
